import styled from 'styled-components';

import { SkeletonProps } from './Skeleton';

export const SkeletonWrapper = styled.div<SkeletonProps>`
  width: ${({ width }) => (width ? `${width}px` : '100%')};
  height: ${({ height }) => (height ? `${height}px` : '100%')};
  border-radius: ${({ borderRadius }) => borderRadius}px;
  margin-bottom: ${({ marginBottom }) => marginBottom}px;
  margin-left: ${({ marginLeft }) => marginLeft}px;
  margin-right: ${({ marginRight }) => marginRight}px;
  position: relative;
  overflow: hidden;
  background-image: linear-gradient(140deg, #ebebeb 1%, #ededed 52%, #ebebeb);
`;

export const ShimmerWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  animation: loading 1.5s infinite;

  @keyframes loading {
    0% {
      transform: translateX(-150%);
    }

    50% {
      transform: translateX(-60%);
    }

    100% {
      transform: translateX(150%);
    }
  }
`;
export const Shimmer = styled.div`
  width: 50%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.4);
  transform: skewX(-20deg);
`;
